import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { IoniconsFilled } from '@pt/pt-models';
import { WidgetUtils } from '../../../widget.utils';
import { WidgetDialogService } from '../../../../services/widget-dialog.service';
import { WidgetSelectValue } from '../../../../widget-component/widget-select/widget-select.component';
import { of } from 'rxjs';
import {
  WidgetRecipientChooserV0ArgsDataValue,
  WidgetRecipientChooserV0ArgsHeader,
  WidgetRecipientChooserV0QueryMapped,
  WidgetRecipientChooserV0Value
} from '../../v0/models/widget-recipient-chooser-v0-preview.dto';

@Component({
  selector: 'pt-wrc-v0-row',
  templateUrl: './wrc-v0-row.component.html',
  styleUrls: [`./wrc-v0-row.component.scss`]
})
export class WrcV0RowComponent implements OnChanges {
  public loading = false;
  id = WidgetUtils.generateId('widget-recipient-chooser-row');
  @Input() value: WidgetRecipientChooserV0Value;
  @Input() header: WidgetRecipientChooserV0ArgsHeader;
  @Input() guarantees: WidgetRecipientChooserV0ArgsDataValue[];
  @Input() recipientEntity: WidgetRecipientChooserV0QueryMapped[];
  @Input() recipientType: WidgetRecipientChooserV0ArgsDataValue[];
  @Input() country: string[];
  @Input() index: number;
  @Input() guaranteesRequired = false;

  @Input() lockedRecipient: string[];
  @Output() clickDelete = new EventEmitter();
  @Output() changeRowValue = new EventEmitter<WidgetRecipientChooserV0Value>();

  public recipientEntityList: WidgetSelectValue[];
  public currentRecipientEntity: WidgetSelectValue;

  public countryList: WidgetSelectValue[];
  public currentCountry: WidgetSelectValue;

  public IconDelete = IoniconsFilled.trash;

  internalValue: WidgetRecipientChooserV0Value;
  purposeHeight = '21px';

  constructor(private widgetDialogService: WidgetDialogService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.lockedRecipient || changes.recipientEntity) {
      const selectValues: WidgetSelectValue[] = this.recipientEntity?.map((r: WidgetRecipientChooserV0QueryMapped) => {
        return {
          uuid: r.uuid,
          label: r.label
        } as WidgetSelectValue;
      });
      let locked = this.lockedRecipient;
      if (this.value && this.value.recipient && locked.includes(this.value.recipient)) {
        locked = locked.filter(l => l !== this.value.recipient);
      }
      this.recipientEntityList = selectValues?.filter((f) => !locked.includes(f.uuid)) || [];
    }


    if (changes.value) {
      this.loading = true;
      this.alignLockedValue();
    }

    if (changes.country) {
      this.loading = true;
      const currentValue: string[] = changes.country.currentValue;
      this.countryList = currentValue?.map((c) => {
        return {
          uuid: c,
          label: c
        } as WidgetSelectValue;
      });
      this.currentCountry = this.countryList?.find((c => c.uuid === this.internalValue?.country));
    }

    if (changes.guarantees) {
      this.loading = true;
      const currentValue: WidgetRecipientChooserV0ArgsDataValue[] = changes.guarantees.currentValue;
      this.purposeHeight = currentValue?.length > 0 ? (currentValue.length * 21) + 'px' : '21px';

    }

    if (this.loading) {
      setTimeout(() => this.loading = false, 200);
    }
  }

  openTextAreaPurpose(value: string) {
    const dialog = this.widgetDialogService.runTextArea(
      of(this.header.purpose),
      value,
      true);
    dialog.subscribe((value) => {
      this.internalValue.purpose = value;
      this.changeRowValue.emit(this.internalValue);
    });
  }

  clickRecipientType(value: string) {
    this.internalValue.recipientType = value;
    this.changeRowValue.emit(this.internalValue);
  }

  clickGuarantees($event: string) {
    if (this.internalValue?.guarantees?.length > 0) {
      if (this.internalValue?.guarantees?.includes($event)) {
        this.internalValue.guarantees = this.internalValue.guarantees.filter((v) => v !== $event);
      } else {
        this.internalValue.guarantees.push($event);
      }
    } else {
      this.internalValue.guarantees = [$event];
    }


    this.changeRowValue.emit(this.internalValue);
  }

  clickExtraUe() {
    this.internalValue.extraUe = !this.internalValue?.extraUe;
    if (!this.internalValue.extraUe) {
      this.internalValue.country = null;
      this.internalValue.guarantees = [];
    }
    this.changeRowValue.emit(this.internalValue);
  }

  changeSelectedRecipientEntity($event: WidgetSelectValue) {
    this.internalValue.recipient = $event?.uuid;
    this.changeRowValue.emit(this.internalValue);
  }

  isGuaranteesChecked(uuid: string) {
    return this.internalValue?.guarantees?.includes(uuid);
  }

  changeSelectedCountry($event: WidgetSelectValue) {
    this.internalValue.country = $event?.uuid;
    this.changeRowValue.emit(this.internalValue);
  }

  private alignLockedValue() {
    const currentRecipientEntity: WidgetRecipientChooserV0QueryMapped[] = this.recipientEntity || [];
    let currentLockedRecipient: string[] = this.lockedRecipient;
    this.internalValue = JSON.parse(JSON.stringify(this.value));
    const currentValue: WidgetRecipientChooserV0Value = this.value;

    // console.groupCollapsed('alignLockedValue ' + this.id);
    // console.warn('Recipient: ', currentRecipientEntity);
    // console.warn('Locked:    ', currentLockedRecipient);
    // console.warn('currentValue:    ', currentValue);
    // console.groupEnd();


    this.recipientEntityList = currentRecipientEntity?.map((r: WidgetRecipientChooserV0QueryMapped) => {
      return {
        uuid: r.uuid,
        label: r.label
      } as WidgetSelectValue;
    });

    if (!!this.internalValue && !!this.internalValue.recipient && currentLockedRecipient.length > 0) {
      currentLockedRecipient = currentLockedRecipient.filter(f => f !== this.internalValue.recipient);
    }
    //
    this.recipientEntityList = this.recipientEntityList?.filter((f) => !currentLockedRecipient.includes(f.uuid)) || [];
    this.currentRecipientEntity = this.recipientEntityList?.find((c) => c.uuid === currentValue.recipient);

  }
}
